import {h, Fragment} from "preact"
import { useAppState } from '@nosto/preact'
import { useState, useEffect } from 'preact/hooks'

import NoResults from './NoResults'
import Products from './Products'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'
import BottomToolbar from './BottomToolbar'
import Loader from './Loader'
import SelectedFilters from './SelectedFilters'

export default () => {
    const {
        query,
        response: { products },
        loading,
    } = useAppState()
    const foundProducts = products && products.total > 0

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768)
        }

        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    useEffect(() => {
        if (!query.query || !products?.hits?.length) return
        const detail = {
            searchQuery: query.query, // The search query that was executed.
            numResults: products.total, // Total results, not just paginated results.
            results: products.hits, // Ideally https://shopify.dev/docs/api/liquid/objects/product
        }
        document.dispatchEvent(new CustomEvent('nosto-search-results', { detail }))
    }, [query, products])

    // Testing
    useEffect(() => {
        const nativeHeader = document.querySelector('#shopify-section-header')
        const headerSentinel = document.querySelector('#header-sentinel')

        const handleScroll = () => {
            const sentinelRect = headerSentinel.getBoundingClientRect()
            if (sentinelRect.top < 0) {
                console.log('Header is out of view')
                nativeHeader.classList.add('animated')
            } else {
                console.log('Header is in view')
                nativeHeader.classList.remove('animated')
            }
        }

        // Initial check to remove 'animated' class on page load
        nativeHeader.classList.remove('animated')

        window.addEventListener('scroll', handleScroll)

        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])
    // End testing

    return (
        <>
            <div id="header-sentinel"></div>
            <div
                id="nosto-search-results-div"
                class="ns-serp ns-d-flex ns-flex-column ns-flex-md-column ns-font-inherit ns-my-0 container"
                data-nosto-element="search">
                {(foundProducts || (loading && foundProducts)) && (
                    <Fragment>
                        {!isMobile && <Sidebar />}
                        <Toolbar mobile />
                    </Fragment>
                )}
                <div
                    class="ns-d-block nosto-block ns-d-md-inline ns-w-100 ns-border-box ns-p-0"
                    style={loading ? 'position: relative;' : ''}>
                    {foundProducts ? (
                        <>
                            {!isMobile && <SelectedFilters />}
                            <Toolbar />
                            <Products isMobile={isMobile} />
                            <BottomToolbar />
                        </>
                    ) : (
                        <NoResults />
                    )}
                </div>
            </div>
        </>
    )
}

// import { useAppState } from '@nosto/preact'

// import NoResults from './NoResults'
// import Products from './Products'
// import Toolbar from './Toolbar'
// import Sidebar from './Sidebar'
// import BottomToolbar from './BottomToolbar'
// import Loader from './Loader'
// import SelectedFilters from './SelectedFilters'

// export default () => {
//     const {
//         response: { products },
//         loading,
//     } = useAppState()
//     const foundProducts = products && products.total > 0

//     return (
//         <div class="ns-serp ns-d-flex ns-flex-column ns-flex-md-column ns-font-inherit ns-p-4 ns-my-0 ns-mx-auto" data-nosto-element="search">

//             {(foundProducts || (loading && foundProducts)) && (
//                 <Fragment>
//                     <Sidebar />
//                     <Toolbar mobile />
//                 </Fragment>
//             )}
//             <div
//                 class="ns-d-block nosto-block ns-d-md-inline ns-w-100 ns-border-box ns-p-0"
//                 style={loading ? 'position: relative;' : ''}
//             >
//                 {loading && foundProducts ? (
//                     <>
//                         {/* <SelectedFilters /> */}
//                         <Toolbar />
//                         <Loader />
//                         <Products />
//                     </>
//                 ) : loading ? (
//                     <Loader />
//                 ) : foundProducts ? (
//                     <>
//                         {/* <SelectedFilters /> */}
//                         <Toolbar />
//                         <Products />
//                         <BottomToolbar />
//                     </>
//                 ) : (
//                     <NoResults />
//                 )}
//             </div>
//         </div>
//     )
// }
